
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comparison/[firstplace]/[secondplace]",
      function () {
        return require("private-next-pages/comparison/[firstplace]/[secondplace].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comparison/[firstplace]/[secondplace]"])
      });
    }
  